"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.default = (function () {
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, 0);
    }, []);
});
